import { Injectable, Output, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  @Output() loggedIn: EventEmitter<any> = new EventEmitter();
  constructor() { }

  destroy(){
    localStorage.removeItem('videostyler:token');
    localStorage.removeItem('videostyler:user');
    localStorage.removeItem('videostyler:tokenExpireAt');
  }

  isAdmin(){
    let user = localStorage.getItem('videostyler:user');
    if(!user) return false;
    let parsedUser = JSON.parse(user);
    return parsedUser.roleId == 2;
  }

  loggedInUser(){
    return JSON.parse(localStorage.getItem('videostyler:user'));
  }

  refreshUser(user){
    localStorage.setItem('videostyler:user', JSON.stringify(user));
  }

  setUser(response){
    localStorage.setItem('videostyler:tokenExpireAt', response.expiresAt);
    localStorage.setItem('videostyler:token', response.token);
    this.refreshUser(response.user);
  }

  logout(){
    this.destroy();
    this.loggedIn.emit(false);
  }

  auth(response){
    this.setUser(response);
    this.loggedIn.emit(true);
    return response.user;
  }

}
